
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Comp_Fix","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"TOP","transform":"translate(-187 -331)","fill":"#333"}},[_c('g',{attrs:{"id":"prg1","transform":"translate(7 116)"}},[_c('g',{attrs:{"id":"Group","transform":"translate(9 214)"}},[_c('g',{attrs:{"id":"Group-7","transform":"translate(169)"}},[_c('g',{attrs:{"id":"icon_s_pin","transform":"translate(0 1)"}},[_c('path',{attrs:{"d":"M8 0a5.5 5.5 0 00-5.5 5.5C2.5 8.538 8 16 8 16s5.5-7.462 5.5-10.5A5.5 5.5 0 008 0m0 1.25a4.255 4.255 0 014.25 4.25c0 1.617-2.309 5.51-4.25 8.34-1.941-2.829-4.25-6.721-4.25-8.34A4.255 4.255 0 018 1.25zm.025 1.739a2.503 2.503 0 00-2.5 2.5c0 1.378 1.121 2.5 2.5 2.5 1.378 0 2.5-1.122 2.5-2.5 0-1.379-1.122-2.5-2.5-2.5zm.006.976c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5z","id":"Fill-1"}})])])])])])])])
          )
        }
      }
    